import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { PayrollConceptSelectFieldFragment } from 'generated/resources/graphql'

import { translations as roleLevelSalaryTranslations } from 'modules/contracts/components/FixFlow/lib/roleLevelSalaryTranslations'
import { useCrudDisclosure } from 'modules/contracts/hooks/useCrudDisclosure'
import { InMemoryAdditionalCompensation } from 'modules/contracts/lib/contractFlowContext'
import { translate } from 'modules/contracts/lib/translate'

import { AdditionalCompensationsList } from './AdditionalCompensationsList/AdditionalCompensationsList'
import {
  CreateAdditionalCompensationFormModal,
  CreateAdditionalCompensationWizardModal,
} from './CreateAdditionalCompensation'
import { DeleteAdditionalCompensation } from './DeleteAdditionalCompensation'
import {
  EditAdditionalCompensationFormModal,
  EditAdditionalCompensationWizardModal,
} from './EditAdditionalCompensation'

type AdditionalCompensationListProps = {
  additionalCompensations: InMemoryAdditionalCompensation[]
  payrollConcepts: PayrollConceptSelectFieldFragment[]
  leaveTypeOptions: Array<{ id: string; label: string }>
  effectiveOn?: string
  contractVersionId: string
  isPerWorkedDayFeatureEnabled?: boolean
}

function ContractAdditionalCompensationList({
  additionalCompensations,
  payrollConcepts,
  leaveTypeOptions,
  effectiveOn,
  contractVersionId,
  isPerWorkedDayFeatureEnabled = false,
}: AdditionalCompensationListProps) {
  const {
    isEditing,
    onEdit,
    onClose,
    editValue,
    isCreating,
    onCreate,
    isDeleting,
    deleteValue,
    onDelete,
  } = useCrudDisclosure<InMemoryAdditionalCompensation>()
  const translations = roleLevelSalaryTranslations()
  const canUsePerWorkedDayWizard = isPerWorkedDayFeatureEnabled

  return additionalCompensations ? (
    <Box gap="s24">
      <Button onClick={onCreate} iconName="add">
        {translate(translations, 'add_compensation')}
      </Button>
      <AdditionalCompensationsList
        additionalCompensations={additionalCompensations}
        onEdit={onEdit}
        onDelete={onDelete}
      />

      {isEditing && editValue ? (
        canUsePerWorkedDayWizard ? (
          <EditAdditionalCompensationWizardModal
            onClose={onClose}
            additionalCompensation={editValue}
            payrollConcepts={payrollConcepts}
            leaveTypeOptions={leaveTypeOptions}
            effectiveOn={effectiveOn}
          />
        ) : (
          <EditAdditionalCompensationFormModal
            onClose={onClose}
            additionalCompensation={editValue}
            payrollConcepts={payrollConcepts}
            effectiveOn={effectiveOn}
          />
        )
      ) : (
        isCreating && (
          <>
            {canUsePerWorkedDayWizard ? (
              <CreateAdditionalCompensationWizardModal
                onClose={onClose}
                payrollConcepts={payrollConcepts}
                leaveTypeOptions={leaveTypeOptions}
                effectiveOn={effectiveOn}
                contractVersionId={contractVersionId}
              />
            ) : (
              <CreateAdditionalCompensationFormModal
                onClose={onClose}
                payrollConcepts={payrollConcepts}
                effectiveOn={effectiveOn}
                contractVersionId={contractVersionId}
              />
            )}
          </>
        )
      )}

      {isDeleting && deleteValue && (
        <DeleteAdditionalCompensation additionalCompensation={deleteValue} onClose={onClose} />
      )}
    </Box>
  ) : null
}

export { ContractAdditionalCompensationList }
